import { z } from 'zod';

import type {
  CoverExportHeader,
  CoverExportResponse,
  CoverExportSummary,
  ExportCoverShipmentRequest,
  ExportCoverShipmentResponse,
} from './export-cover-shipment.dto.js';
import { ShipmentDailyRegularRowSchema } from '../shipments/export-shipment-daily-regular.schema.js';
import { CoverShipmentInboundAttachmentReportRowSchema } from './get-cover-shipment-report.schema.js';
import { ReportableWeightLbSchema } from '../reportable-weight.schema.js';

const nonNegativeNumberSchema = z.number().min(0);
const nonNegativeIntSchema = z.number().int().min(0);

export const ExportCoverShipmentRequestSchema: z.ZodType<ExportCoverShipmentRequest> = z
  .object({
    companyId: z.uuid(),
    coverShipmentId: z.uuid(),
  })
  .strict();

export const CoverExportHeaderSchema: z.ZodType<CoverExportHeader> = z
  .object({
    processorReceivedWeightLb: ReportableWeightLbSchema.nullable(),
    timeZone: z.string().trim().min(1),
  })
  .strict();

export const CoverExportSummarySchema: z.ZodType<CoverExportSummary> = z
  .object({
    inboundContributionWeightLb: ReportableWeightLbSchema,
    inboundContributionRefundValueCents: nonNegativeIntSchema,
    inboundPhysicalReceivedWeightLb: nonNegativeNumberSchema,
    ownPurchaseWeightLb: ReportableWeightLbSchema,
    ownPurchaseRefundValueCents: nonNegativeIntSchema,
    documentTotalWeightLb: ReportableWeightLbSchema,
    documentTotalRefundValueCents: nonNegativeIntSchema,
  })
  .strict();

export const CoverExportResponseSchema: z.ZodType<CoverExportResponse> = z
  .object({
    header: CoverExportHeaderSchema,
    dailyRegularRows: z.array(ShipmentDailyRegularRowSchema),
    inboundAttachmentRows: z.array(CoverShipmentInboundAttachmentReportRowSchema),
    summary: CoverExportSummarySchema,
  })
  .strict();

export const ExportCoverShipmentResponseSchema: z.ZodType<ExportCoverShipmentResponse> =
  CoverExportResponseSchema;
